import { create } from 'zustand'
export const usePwaUpdateStore = create<{
  applying: boolean
  setApplying: (value: boolean) => void
  available: boolean
  openRequest: number
  setAvailable: (value: boolean) => void
  open: () => void
}>(set => ({
  applying: false,
  setApplying: applying => set({ applying }),
  available: false,
  openRequest: 0,
  setAvailable: available => set({ available }),
  open: () => set(state => ({ openRequest: state.openRequest + 1 })),
}))
